// src/Dashboard/pages/user/Absences/components/StatusBadge.jsx

import React from "react";
import { getAbsenceStatus } from "../utils/absenceUtils";

export default function StatusBadge({ adherent }) {
  if (!adherent) return null;

  const status = getAbsenceStatus(adherent);
  const Icon = status.icon;

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-bold ring-1 ${status.badge}`}
    >
      <Icon className="text-[10px]" />
      {status.label}
    </span>
  );
}